import { useContext, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';
import { Group, Stack, Text } from '@mantine/core';
import { fetchContractTemplates } from '../../../../Service/restapi/contractService';
import { ContractTemplateListActions } from '../../../../Molecules/Settings/ContractTemplates/ContractTemplateListActions';
import { MediaUpload } from '../MediaUpload';
import { createContractTemplateByName } from '../../../../Service/restapi/contractTemplateService';
import ContractTemplateNameModal from '../../../../Organismns/Settings/Documents/ContractTemplates/ContractTemplateNameModal';
import { ProfileContext } from '../../../../Service/Context/ProfileContext';
import { LoadingAnimation } from '../../../../Service/ResourceAdapter';
import { useModalState } from '../../../../Molecules/Dialogs';
import PanePaper from '../../../../Molecules/PanePaper';
import BookitupAddIcon from '../../../../Atoms/BookitupAddIcon';
import { ViolationContext } from '../../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../../Service/LicenceS';
import { RoutingS } from '../../../../Service/RoutingS';
import { MixpanelS } from '../../../../Service/MixpanelS';
import { ConstantS } from '../../../../Service/ConstantS';
import EmptyText from '../../../../Atoms/EmptyText';
import SkeletonItems from '../../../../Atoms/SkeletonItems';
import { openCreateTemplateModal } from '../../../../Organismns/Settings/Documents/ContractTemplates/ContractTemplateModals';
import BookitupNumberInput from '../../../../Atoms/inputs/BookitupNumberInput';
import ContractTemplateWorkflow from './Template-DJ/ContractTemplateWorkflow';
import StandardLayoutContent from './StandardLayoutContent';

// eslint-disable-next-line import/prefer-default-export
export const ContractTemplates = () => {
  const { profile, patchProfile } = useContext(ProfileContext);
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { show, toggle } = useModalState();
  const [contracts, setContracts] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { fixEngagementUntil } = profile;

  useEffect(() => {
    RoutingS.changeTitle('Vertrags-Vorlagen');
    loadContracts();
  }, []);

  function loadContracts() {
    setLoading(true);
    fetchContractTemplates()
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((newContracts) => {
            setContracts(newContracts);
          });
        } else {
          console.error('could not load contracts');
        }
      })
      .catch((error) => {
        console.error({ error });
        console.error('could not load contracts');
      })
      .finally(() => setLoading(false));
  }

  function create(name) {
    createContractTemplateByName(name)
      .then((resp) => {
        if (resp.ok) {
          MixpanelS.track(ConstantS.TrackingEvents.ContractTemplateCreated, { default: false });
          navigate(`/settings/template/contract/${name}`);
        } else {
          console(`could not create contract template ${name}`);
        }
      })
      .catch((error) => {
        console.error(`could not create contract template ${name}`);
        console.error(error.message);
      });
  }

  const styles = {
    actions: {
      marginBottom: 5,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    list: {
      backgroundColor: 'white',
      borderRadius: 5,
      paddingTop: 5,
      paddingBottom: 5,
    },
    itemContainer: {
      marginBottom: 5,
      display: 'flex',
    },
  };

  const items = [];
  if (!contracts) {
    return <LoadingAnimation />;
  }

  contracts.map((value, index) => {
    items.push(
      <Group position="apart">
        <Stack spacing={0}>
          <Text
            className="underline-hover"
            size="md"
            onClick={() => navigate(`/settings/template/contract/${value.name}`)}
          >
            {value.name}
          </Text>
          <Text size="xs" color="dimmed">
            Bearbeitet{'  '}
            <Moment fromNow date={value.lastModified} />
          </Text>
        </Stack>
        <div>
          <ContractTemplateListActions templateName={value.name} reloadDocuments={loadContracts} />
        </div>
      </Group>,
    );
  });
  return (
    <Stack sx={{ maxWidth: 550 }}>
      <PanePaper
        title="contract.templates"
        tooltip="help.settings.contract.templates.pane"
        rightSection={
          <BookitupAddIcon
            onClick={() =>
              executeWithLicenceCheck(LicenceS.Restrictions.CONTRACT_USAGE, () =>
                openCreateTemplateModal({ existingNames: contracts.map((c) => c.name) }),
              )
            }
          />
        }
      >
        {loading && <SkeletonItems mt="xs" height={70} />}
        {!loading && contracts.length === 0 && <EmptyText />}
        {!loading && (
          <Stack mt="sm">
            {items}
            <ContractTemplateWorkflow reloadContracts={loadContracts} />
          </Stack>
        )}
        <ContractTemplateNameModal show={show} toggle={toggle} finish={create} />
      </PanePaper>

      <StandardLayoutContent />

      <MediaUpload
        showPreview
        kind="signature"
        title="Unterschrift"
        text="Hier kannst Du ein Bild Deiner Unterschrift hineinziehen"
        setLastModified={() => {}}
      />
      <PanePaper title="document.deadlines">
        <BookitupNumberInput
          placeholder=" - "
          label="Vertragszusendung/Anzahlung innerhalb (in Tagen)"
          defaultValue={fixEngagementUntil}
          onBlurSave={(val) => patchProfile({ fixEngagementUntil: val })}
        />
      </PanePaper>
    </Stack>
  );
};
